<template>
  <div class="home">
    <div class="home-shuffling">
        <img class="home-img" src="../assets/help-banner.jpg">
        <div class="home-help-name">帮助中心</div>
    </div>
    
    <div class="help-nav">
        <el-tabs type="card">
            <el-tab-pane label="常见问题">

                <el-collapse v-model="activeName" accordion>
                    <el-collapse-item title="怎么知道附近有没有布瑞琳洗衣店？" name="1">
                        <div>查询附近有没有布瑞琳洗衣店，可在高德、百度、腾讯地图搜索“布瑞琳”，也可关注“布瑞琳洗衣”公众号，进入小程序，查询附近门店。</div>
                    </el-collapse-item>
                    <el-collapse-item title="在布瑞琳洗衣如何收费？" name="2">
                        <div>按件清洗，也可办理会员卡，套餐卡清洗，布瑞琳各门店价格统一，详细价格可咨询门店</div>
                    </el-collapse-item>
                    <el-collapse-item title="送洗衣物几天可以洗好" name="3">
                        <div>常规衣物一般在72小时即可洗完送回，特殊衣物可能会有一定时间延长。</div>
                    </el-collapse-item>
                    <el-collapse-item title="衣物在哪里清洗？" name="4">
                        <div>衣物统一送到布瑞琳中央工厂进行洗护，洗好后由自有物流送回门店，并通知客户取衣。</div>
                    </el-collapse-item>
                    <el-collapse-item title="布瑞琳可以洗护什么衣物？" name="5">
                        <div>目前布瑞琳价目表内的衣物均可洗护，后续可能会开放更多洗护类目。</div>
                    </el-collapse-item>
                    <el-collapse-item title="布瑞琳洗衣能不能上门取送？" name="6">
                        <div>办理布瑞琳会员卡，可以享受上门取送服务，具体价格可详询门店。</div>
                    </el-collapse-item>
                    <el-collapse-item title="附近没有布瑞琳洗衣门店，如何下单？" name="7">
                        <div>可微信关注“布瑞琳洗衣”公众号，进入布瑞琳洗衣小程序，选择洗护衣物类目，下单即可。</div>
                        <div>也可在天猫，美团大众，口碑，盒马等平台下单。</div>
                    </el-collapse-item>
                    <el-collapse-item title="布瑞琳可以为集团性大客户提供洗衣服务吗？" name="8">
                        <div>可以。布瑞琳目前已为百余家集团大客户提供洗护服务，并有专人负责衣物洗护服务。</div>
                    </el-collapse-item>
                </el-collapse>

            </el-tab-pane>
            <el-tab-pane label="洗护知识">
                <el-collapse v-model="activeWashProtect" accordion>
                    <el-collapse-item title="洗衣服浸泡多长时间合适？" name="1">
                        <div>许多人洗衣服前一泡就是几个小时，认为泡得越久洗得越干净，然而事实正相反。浸泡时间过长，洗衣液中的化学物质以及衣物中的污渍更容易分解，发出臭味。污水无法流失，时间久了，会进入衣物纤维内，令衣服褪色、老化。一般来说，浸泡脏衣服以15分钟为宜，即使是厚重的衣服，浸泡时间也不能超过30分钟。</div>
                    </el-collapse-item>
                    <el-collapse-item title="窗帘要多长时间洗一次合适？" name="2">
                        <div>窗帘离窗口最近，外界的灰尘最先到达窗帘。如果长年累月不洗，上面沾染了大量的灰尘和尘螨，尤其是颜色深的窗帘。如果室内通风差，或者墙面潮湿，还容易滋生霉菌或其他细菌。这是室内空气质量差的重要原因。</div>
                        <div>有孩子或养宠物的家庭，要坚持三个月到半年彻底清洁一次。窗帘可以直接放在洗衣机里洗，也可以干洗。洗后放在阳光充足的地方晾晒后再用，或者直接挂好，不但方便晾干，还是免费的空气“加湿器”。此外，如果家中有呼吸道疾病或其他传染性疾病患者，清洗窗帘时，最好先消毒。</div>
                    </el-collapse-item>
                    <el-collapse-item title="为什么衣服洗完之后会变硬？" name="3">
                        <div>出现这种情况，一个原因是因为水质，我们一般都是用没有经过任何处理的自来水洗衣服，而自来水的水质偏硬，使用这种水洗衣服，水中的硬质就会渗入到衣服中，在晾干之后，衣物自然就会变硬。第二个原因跟洗涤产品有关，有些廉价洗衣产品中所含的硬质较多，用后容易使衣服变硬。最后一个原因就是洗涤剂和水中的杂质、衣物杂质等发生了皂化反应，皂化反应就是肥皂里的有效成分硬脂酸钠，这种物质可以溶于水，用硬水洗涤的过程中，它的钙、镁离子会把钠离子置换下来，就变成了硬脂酸钙和硬脂酸镁，这种物质在水中的溶解度就会变小，它就像是一些细小颗粒，附着在衣物纤维上面，就像是衣物上覆盖了很多水垢一样，这样一来衣物晾晒后就会变得很硬。此外，衣服反复洗涤会使纤维缠绕，衣服失去弹性，导致衣服变硬。</div>
                        <div>那么衣物洗后发硬应该如何处理呢？对于水质问题，建议在家中安装水质软化设备，使用软水有很多好处，使用软水洗衣物，可以有效节省各种洗涤剂50%～80%，降低衣物的磨损程度，使衣物洗后松软，色泽保持更长久。并且软水还会减少家中生活器具污垢的产生。但软水的获取需要付出时间和金钱成本，所以从洗涤产品上出发更加经济实惠，尽量挑选质量好的洗涤产品，建议在洗涤过程中使用合适的柔顺剂，但要适量，尽量避免用来洗内衣和贴身衣物。</div>
                    </el-collapse-item>
                    <el-collapse-item title="白色衣服脏了有什么办法可以洗干净？" name="4">
                        <div>1、用84消毒液浸泡   严格按照使用说明稀释和浸泡，去黄效果是显而易见的。</div>
                        <div>2、用白醋洗白   在清水中加入几滴白醋，将白色衣服浸入其中搓洗，捞出后按照普通洗衣程序清洗干净即可。</div>
                        <div>3、盐水浸泡   在温水中加点食盐，将衣服浸泡30分钟，再用肥皂水清洗干净。盐水清洗后再加白醋浸泡，还可以消除汗渍味儿，起到杀菌除臭的作用。</div>
                        <div>4、蓝色墨水洗白，  一盆清水中加入3~5滴纯蓝墨水（比例30:1），搅拌均匀，将漂洗干净的白色衬衫放进水里，上下提拉3~5次，捞出晾干，可以去除黄渍。</div>
                        <div>5、双氧水浸泡   将衣服放进10:1的双氧水中浸泡15分钟，然后将衣服捞出来，正常清洗晾干即可。</div>
                        <div>6、柠檬汁洗白
                                 1）洗白色衣服的时候，在水里加点柠檬汁，可以使衣服更加洁白。
                                2）在衣服泛黄处滴上新鲜的柠檬汁，用盐轻轻揉搓，然后放在阳光上暴晒，也能去除黄斑。
                        </div>
                        <div>7、洗米水浸泡
                            将白色的衣服泡入淘米水中，加上洗衣液正常清洗，可以让发黄的衣服白回来。白色的衣服经常用淘米水清洗，不容易发黄，省劲儿更省钱~
                        </div>
                        <div>如何防止白衣服发黄？</div>
                        <div>1、及时清洗
                            不管是什么季节，白色的衣服穿过后都及时清洗，晾干，才能避免发黄。
                        </div>
                        <div>2、避免暴晒
                            将白色衣服翻过来，里面朝外晾晒，或者衣服洗好后在阴凉的地方晾干，都可以避免衣服发黄。
                        </div>
                        <div>3、正确存放
                            保存不当白色衣服也会发黄。换季的时候将白色的衣服清洗晾干，进行熨烫杀菌后装进密封的袋子里，可以最大程度避免衣服发黄。
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="洗衣服有些衣服为什么会串色？" name="5">
                        <div>我们在清洗衣服的时候一直都建议大家不同颜色的衣服要分开清洗，不然会有串色的可能，也是我们常说的衣服染色。那为什么清洗衣服时会串色呢？串色后该怎么解决？以后又要如何避免串色呢？</div>
                        <div>1、衣服面料由于使用不同的纺织纤维所以存在着不同的色牢度差异，合成纤维织物色牢度高于天然纤维和人造纤维织物。</div>
                        <div>2、衣物面料轻薄，洗涤频率高也容易出现串色现像。</div>
                        <div>3、在洗涤过程中因使用不当的清洗剂造成服装面料掉色，如真丝、毛料织物属于蛋白质纤维，不可使用强碱型洗涤剂，否则会造成服装面料不同程度的掉色。</div>
                        <div>4、因洗涤操作不当造成的服装面料色牢度问题。如衣物浸泡、洗涤时间过长、水洗温度过高、衣物在晾晒时受到太阳的直射、熨烫时超过面料所能承受的温度、洗刷去渍时用力过大等都会对服装色泽造成一定的影响，出现不同程度的退色现象。</div>
                        <div>衣服如果已经发生串色了，我们用串色洗涤剂就可以洗掉，洗涤剂通常有彩漂、漂白水、保险粉、AB消色清洗剂。</div>
                        <div>1、彩漂，几乎所有面料能用（涂层面料例如羽绒服面料、皮革勿用），洗涤时添加适量洗衣粉效果更佳。长时间浸泡对串色有一定作用。</div>
                        <div>2、漂白水，只适用于全涤面料，洗串色速度快，效果看的见。</div>
                        <div>3、保险粉，粉剂，需倒入70度左右水中稀释后分解再用。用法和性质如漂白水。</div>
                        <div>4、AB消色清洗剂，分A、B两种原液，只需在串色处同时涂上，串色即消失，适合大批量串色清洗。</div>
                        <div>如何避免衣服串色？</div>
                        <div>1、首先洗衣服的时候一定要区分开深色和浅色，这样分开洗会更好的防止串色，同时也能更好的清洗干净。</div>
                        <div>2、再就是用多个脸盆分开泡这些深浅的衣服，然后就各自清洗一遍，这样就不会混在一起洗而被染色了。</div>
                        <div>3、其次就是一件一件的清洗，这样就会更好的清洗每件衣服，同时先清洗浅色衣服，再清洗深色衣服。</div>
                        <div>4、再就是放入洗衣机清洗衣服就需要放上一块避免串色的纸片，这样无论如何怎么洗都不会串色了，网上都会有购买的。</div>
                        <div>5、然后就是尽量用冷水来洗衣服，同时不要用力的揉搓衣服，这样会导致衣服掉色更严重，所以应当轻轻的清洗会更好。</div>
                        <div>衣服掉色是很正常的，学会把衣服分类，不管是清洗还是收纳，我们只要懂得如何清洗就可以完全避免了。</div>
                    </el-collapse-item>
                    <el-collapse-item title="几种常见的洗衣误区？" name="6">
                        <div>1、洗涤剂用的越多，衣服洗得越干净，当洗涤剂用量超过标准时多余的洗涤剂不仅不能增加去污力，反而容易残留在衣物上，不易清洗，还会刺激皮肤，如果洗涤剂含有漂白作用，过量使用更会使衣物褪色、损伤。</div>
                        <div>2、机洗不如手洗干净，如果有好的洗衣机和好的洗涤产品，机洗可以比手洗还干净。</div>
                        <div>3、洗衣时水温越高越好，有朋友认为水温越高除渍效果就越好，杀菌效果也越好，所以在使用带加热的洗衣机时将温度调到最高，冬天手洗衣物时也用较热的水洗衣，这种做法是错误的。对于血渍等有蛋白质的污渍，用热水浸泡后会牢固地粘附在衣物上，所以应用冷水洗涤，过热的水也会使棉质、羊毛、羊绒制品缩水、变形，长时间浸泡还会造成衣物褪色等。所以一般情况下，水温应在30-40度之间最佳</div>
                        <div>4、脏衣服存放在洗衣机中，洗衣时放入水和洗涤剂清洗。脏衣服应在透气的洗衣袋或洗衣盆中存放，如放在密不透风的洗衣机中，时间长了，衣服上的汗渍、污物就会反味儿，细菌更容易滋生，严重的还会发霉。洗衣时，应先放入洗涤剂，特别是洗衣粉，由于是粉状物，不易溶解，更应先用水化开后才能更好地发挥它的功效，以免冲洗不净，造成残留。正确的方法是：先将洗涤剂溶于水，然后放入待洗衣物，浸泡十分钟后再清洗。</div>
                        <div>5、许多人洗衣服前一泡就是几个小时，认为泡得越久洗得越干净，然而事实正相反。浸泡时间过长，洗衣液中的化学物质以及衣物中的污渍更容易分解，发出臭味。污水无法流失，时间久了，会进入衣物纤维内，令衣服褪色、老化。一般来说，浸泡脏衣服以15分钟为宜，即使是厚重的衣服，浸泡时间也不能超过30分钟。</div>
                        <div>6、衣服喜欢攒在一起洗。在温气温比较高，炎热的季节尤其是夏天，人体爱出汗，汗渍就很容易留在衣服上，被汗水浸湿的衣服容易发霉，如果与其他需要洗的衣服混在一起，污染就会增加，本来没有发霉的衣服，也被污染了。而且如果你用洗衣机洗的话，把大量的衣服放进一起洗，是很难轻易干净的。放入的衣物量，最好占衣机内筒容积的70%左右。</div>
                        <div>7、污渍要使劲搓。当衣服染上污渍后，我们总是对有污渍的那一块，进行使劲的搓洗，其实这样也是错误的方法。当衣服被果汁和蔬菜汤污染时，人们往往在清洗过程中对那一块大力搓洗，这样会适得其反，使衣服上的污渍越来越大，甚至磨损衣物。建议当衣服一旦被污渍污染时，应立即用干净的纸巾或手帕进行吸干，以避免其他地方的污染，然后再用清洁的水和洗涤剂进行轻柔擦洗。</div>
                        <div>8、洗完不立刻晾起来。许多上班族喜欢在洗完衣服后，早上把衣服扔到洗衣机里，晚上回来时再把洗衣机里的衣服晾起来，这样也是错误的。湿衣服很长一段时间都放在洗衣机里，是很容易滋生细菌的。所以不要偷懒，清洗完毕后，就马上晾起来吧。</div>
                        <div>9、干洗比水洗效果好。衣服的面料不同，洗涤方式也不同，可以根据衣服标签上的洗涤标识进行清洗，不选择正确的洗涤方式，衣服很容易被洗坏。</div>
                        <div>10、自己洗不干净的衣服，洗衣店能洗干净。洗衣店确实在洗涤知识，洗涤技术，设备和洗剂上更先进，但对于有些难洗的污渍，比如污渍已经渗入衣服纤维，洗衣店也是比较难洗的。所以，到洗衣店洗衣服可以提前咨询能不能洗干净。</div>
                    </el-collapse-item>
                    <el-collapse-item title="羽绒服适合水洗还是干洗？" name="7">
                        <div>大部分羽绒服是可以水洗的，为什么不能干洗？干洗溶剂会破坏羽绒表面的天然油脂，从而会导致羽毛发脆、折断、失去蓬松感。同时羽绒的保暖性主要是靠羽绒的油脂来维持的，这样一来，也就破坏了羽绒的保暖性能，降低使用寿命。</div>
                        <div>不需要干洗，是不是自己在家就可以处理呢？一般的羽绒服都比较贵，在家清洗，如果方法不当，容易在羽绒服表面残留洗衣液导致表面变得斑驳，最好是专门的洗涤剂。如果在家机洗，在洗衣机高速反转搅动下，羽绒很可能结团甚至流失，另一方面洗涤不当还可能引起爆炸事故。另外羽绒服也不能在太阳下暴晒，还要通过敲打的方式让羽绒恢复蓬松。干洗店有专用的水洗、干洗设备，可以加强羽绒服的蓬松度及保暖性！</div>
                        <div>羽绒服清洗三大忌：一忌机洗；二忌用碱性洗涤剂；三忌拧干。</div>
                    </el-collapse-item>
                    <el-collapse-item title="衣服发霉了怎么处理？怎么预防衣物发霉？" name="8">
                        <div>1、阳光暴晒，暴晒后，用刷子刷掉霉毛，加上绿豆芽或酒精擦拭。</div>
                        <div>2、棉质衣物发霉可以用几根绿豆芽在有霉斑的地方反复揉搓，然后在进行正常洗涤即可。</div>
                        <div>3、呢绒衣物发霉在太阳下暴晒一段时间后用刷子能去除霉菌，如果是由于油渍、汗渍耳引起的发霉，可用少量汽油刷洗。</div>
                        <div>4、丝绸衣物发霉可以涂5%的酒精溶液进行擦洗，然后在水中浸泡清洗干净即可。</div>
                        <div>5、皮革衣物发霉可以使用毛巾蘸肥皂水进行擦洗，然后在阴凉通风出晾干即可。</div>
                        <div>怎么预防衣物发霉？</div>
                        <div>1、衣柜保持干燥通风，能有效避免发霉。当然，衣服也需要晾晒的干透了之后再收进来放进衣柜。</div>
                        <div>2、在衣柜中放一些橘子皮，橘子皮不仅可以预防发霉，还能去除衣服久放产生的异味。不过橘子皮需要经常更换，以免腐烂适得其反。</div>
                        <div>3、在衣柜周围贴上纸巾，纸巾有非常强的吸附功能，能够吸出衣柜的湿气，从而有效防止发霉。</div>
                        <div>4、定期将衣服拿出来在太阳底下晒一会儿，自然能有效避免衣物发霉。</div>
                        <div>5、将衣物抽真空收纳，既节约空间又能有效的防止衣物发霉。</div>
                    </el-collapse-item>
                </el-collapse>
                <!-- <ul class="help-problem">
                    <li>
                        <span>干洗与水洗的区别</span>
                        <img src="../assets/right.png" alt="">
                    </li>
                    <li>
                        <span>干洗与水洗的区别</span>
                        <img src="../assets/right.png" alt="">
                    </li>
                    <li>
                        <span>干洗与水洗的区别</span>
                        <img src="../assets/right.png" alt="">
                    </li>
                    <li>
                        <span>干洗与水洗的区别</span>
                        <img src="../assets/right.png" alt="">
                    </li>
                    <li>
                        <span>干洗与水洗的区别</span>
                        <img src="../assets/right.png" alt="">
                    </li>
                </ul> -->
            </el-tab-pane>
        </el-tabs>
    </div>
    
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },

  data(){
    return {
        activeName: '',
        activeWashProtect: '',
    }
  }
  
}
</script>
<style scoped lang="scss">
.home{
    // position: absolute;
    // top: 0;
    width: 100%;
    background: #F3F5FA;
    overflow: hidden;
    margin-top: -91px;
}
.home-shuffling{
    display: flex;

    .home-help-name{
        margin-left: -100%;
        color: #fff;
        width: 100%;
        height: 28.5rem;
        line-height: 28.5rem;
        font-size: 3rem;
    }
}
.home-img{
  width: 100%;
  height: 28.5rem;
}

.help-nav{
    padding: 2rem 12rem 4rem;
}
::v-deep .el-tabs--card>.el-tabs__header{
    border: none;
    margin: 0;
}
::v-deep .el-tabs__item.is-active{
    background: #fff;
    color: #00146E;
}

.help-problem{
    background: #fff;
    padding: 1rem 2rem 3rem;
    list-style: none;
    width: 100%;

    li{
        border-bottom: 1px solid #AFBECD;
        width: 60%;
        line-height: 3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img{
            width: 1rem;
        }
    }
}
::v-deep .el-collapse{
    border: none;
    padding: 1rem 2rem 3rem;
    background: #fff;
    text-align: left;
}
::v-deep .el-collapse-item{
    background: #fff;
    padding: 0 2rem;
}
::v-deep .el-collapse-item__header{
    width: 60%;
    border-bottom: 1px solid #AFBECD;

    .el-collapse-item__arrow{
        font-weight: bolder;
    }
}
::v-deep .el-collapse-item:last-child{
    margin: 0;
}
::v-deep .el-collapse-item__content{
    padding: 2rem;
    color: #666;
    background: #F3F5FA;
}
</style>